export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00201.64b34dc8.png";